import { Form, Formik } from 'formik'
import React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import Button from '../../../../../components/buttons/buttons.component'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import { routes } from '../../../../../constants/routes.constants'
import { couponConstants } from './../../../../../constants/coupon-type.constants'
import {
	SelectInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 2.7rem;
`

const couponTypeOptions = [{ label: 'Todos', value: '' }].concat(
	couponConstants.couponTypeOptions
)

const schema = Yup.object().shape({})
const initialValues = {
	name: '',
	active: '',
	couponType: ''
}

class SearchForm extends React.Component {
	render() {
		const { onSubmit } = this.props
		return (
			<div>
				<Formik
					initialValues={initialValues}
					onSubmit={onSubmit}
					validationSchema={schema}
					render={props => (
						<Form className="form" noValidate>
							<StyledFlexContainer>
								<TextInput
									className={'col-7'}
									id="name"
									label="Nome"
									maxLength={128}
									autoFocus={true}
									{...props}
								/>
								<SelectInput
									className={'col-3'}
									id="couponType"
									label="Tipo"
									defaultValue={{ value: '', label: 'Todos' }}
									options={couponTypeOptions}
									multi={false}
									{...props}
								/>
								<SelectInput
									className={'col-2'}
									id="active"
									label="Situação"
									defaultValue={{ value: true, label: 'Ativos' }}
									options={statusOptions}
									multi={false}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledButtonContainer>
								<Button
									onClick={() =>
										this.props.history.push(
											`${routes.ADMIN}/incluir-cupom`
										)
									}
									secondary
									style={{ marginRight: '15px' }}
									type="button"
									data-permission="A01BF0AED71CC02ABD51DAD265D5D399E5B8EBB0">
									Novo
								</Button>
								<Button
									data-permission="F5825B6EAE1FD289E2AB1F87AF27CC40598B95BC"
									primary
									type="submit">
									Consultar
								</Button>
							</StyledButtonContainer>
						</Form>
					)}
				/>
			</div>
		)
	}
}

const statusOptions = [
	{ value: '', label: 'Todos' },
	{ value: true, label: 'Ativos' },
	{ value: false, label: 'Inativos' }
]

export default SearchForm
